import { Releve, ResponseReleve } from './account_model'
import moment from 'moment'
import { PostDdlDocumentModel } from '../docs/docs_model'
import langEnum from '../../../../enums/langEnum'
import fetchFactory from '../../../../utils/fetchFactory'
import { configEnum, types } from '../../../../enums/fetchFactoryEnum'
import { saveInteractions } from '../../../gtm/utils/gtmCallback'
import { formatDate } from '../../../../utils/formatDate'

export const convertAccountStatementReleve = (list: ResponseReleve[]) =>
    list.map((item: ResponseReleve) => convertReleve(item))

export const convertReleve = (item: ResponseReleve) => ({
    facture_mttcrestant: item.FACTURE_MTTCRESTANT,
    operation_date: moment(item.OPERATION_DATE, 'ddd MMM DD HH:mm:ss zz YYYY', langEnum.en).toDate(),
    operation_mtcredit: item.OPERATION_MTCREDIT,
    operation_mtdebit: item.OPERATION_MTDEBIT,
    operation_type: item.OPERATION_TYPE,
    bail_ref: item.BAIL_REF,
    exist_doc: item.EXIST_DOC,
    doc_id: item.DOC_ID,
    doc_dwstoredatetime: new Date(item.DOC_DWSTOREDATETIME),
    doc_renommage_fr: item.DOC_RENOMMAGE_FR,
    doc_renommage_en: item.DOC_RENOMMAGE_EN,
    doc_titre_object: item.DOC_TITRE_OBJECT,
    piece_numero: item.PIECE_NUMERO,
    date_exigible: item.FACTURE_EXIGIBLE ? mapDate(item.FACTURE_EXIGIBLE) : undefined
})

//Fetch for pdf to ddl
export const downloadOperationPDF = (op: Releve, intl_locale: string, setLoadingDdl: (value: (((prevState: boolean) => boolean) | boolean)) => void) => {
    setLoadingDdl(true)
    const date: string = ` - ${formatDate(new Date(op.doc_dwstoredatetime), 'fr-CA', true)}.pdf`
    let filename: string = intl_locale === langEnum.fr ? `${op.doc_renommage_fr}${date}` : `${op.doc_renommage_en}${date}`
    filename = filename.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    filename = filename.replace(/[^\x20-\x7E]+/g, '')
    const dwdocid: PostDdlDocumentModel = {
        id: op.doc_id,
        filename: filename
    }
    fetchFactory(
        `/api/ec_${process.env.REACT_APP_TARGET}/contrat/telechargeDocument`,
        {
            body: JSON.stringify(dwdocid),
            method: configEnum.post
        },
        types.blob
    )
        .then(
            (blob: any) => {
                saveInteractions(
                    {
                        category: 'Votre compte',
                        action: 'Téléchargement de documents',
                        label: filename
                    }
                )

                const url = window.URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                a.download = filename
                a.click()
            }
        )
        .finally(
            () => {
                setLoadingDdl(false)
            }
        )
}

export const mapDate = (date: string) => {
    let [jour, mois, annee] = date.split("-");

    const formattedJour = parseInt(jour, 10);
    const formattedMois = parseInt(mois, 10) - 1;
    const formattedAnnee = parseInt(annee, 10);

    return new Date(formattedAnnee, formattedMois, formattedJour);
}